// HEAD DATA
export const headData = {
    pageTitle: 'Marion Lintz | Ingénieure logiciel', 
    title: 'Marion Lintz', 
    lang: 'fr', 
  };

export const email = 'contact';
export const mailDomain = 'marionl.fr';